import type { CustomsConfig } from '#types/config/components/customs'
import type { RecursivePartial } from '#types/utils'

export default {
  homeLink: '/custom-shoes'
} satisfies RecursivePartial<CustomsConfig['header']>
